// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__38Vu5","errorLogs":"styles_errorLogs__xb6eD"};